import capitalize from 'lodash/capitalize';

import { MdlIndicationLimitType } from '../../../../graphql';

export const limitTypeOptions = Object.values(MdlIndicationLimitType).map(limitType => ({
  label: capitalize(limitType),
  value: limitType,
}));
